import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { ToastService, ConfirmationService } from 'primevue'
import { VueQueryPlugin } from '@tanstack/vue-query'
import { setupInterceptors } from '@lingoking-node-apps/api'
import { useAuthStore } from '@/stores/auth'

import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import router from './router'
import PrimeVue from 'primevue/config'
import App from './App.vue'
import { AppTheme } from './theme'

import 'primeicons/primeicons.css'
import './style.css'
import './icon-lingoking.css'

const pinia = createPinia()

pinia.use(piniaPluginPersistedstate)

const app = createApp(App)

app.use(VueQueryPlugin)

app.use(pinia)

app.use(router)

app.use(ToastService)

app.use(ConfirmationService)

app.use(
  PrimeVue as any,
  {
    theme: {
      preset: AppTheme,
      options: {
        darkModeSelector: '.dark',
        cssLayer: {
          name: 'primevue',
          order: 'tailwind-base, primevue, tailwind-utilities'
        }
      }
    }
  } as any
)

const { refresh } = useAuthStore()

setupInterceptors(refresh, {
  ignoreSwitchUser: true
})

app.mount('#app')
